import appApi from "@/api/appApi";
import authSerivce from "@/services/auth";
import { showAlert } from "@/core/common/";
import { rbAuthToken } from "@/config/constants";
import userService from "@/services/user";
import { openModal as openSignupModal } from "@/components/profile/auth/Signup";

const UserSatus = {
  InactiveVk: 2,
  Active: 3
};

const accountRedirectSDK = new window.UnifiedLoginSDK.RBAccounts({
  token: rbAuthToken
});

const state = {
  token: localStorage.getItem("user-token") || "",
  status: null,
  currentUser: null
};

const getters = {
  authStatus: s => s.status,
  isAuthenticated: s => !!s.currentUser,
  isAuthLoading: s => s.status === "loading",
  user: s => s.currentUser
};

const mutations = {
  authRequest(state) {
    state.status = "loading";
  },
  authSuccess(state, user) {
    state.status = "success";
    state.currentUser = user;
  },
  authError(state) {
    state.status = "error";
  },
  authLogout(state) {
    state.token = "";
    state.currentUser = null;
  },
  setToken(state, newValue) {
    state.token = newValue;
  },
  setUser(state, user) {
    state.currentUser = user;
  },
  updateUser(state, userData) {
    state.currentUser = Object.assign({}, state.currentUser, userData);
  }
};

const actions = {
  async init({ state, dispatch }) {
    const user = await accountRedirectSDK.init();
    if (state.token) {
      setDefaultAuthHeaders(state.token);
      await dispatch("getProfile");
    } else {
      if (user) await dispatch("login", user.userTokens.id_token);
    }
  },

  async setToken({ commit }, token) {
    token = token || "";
    token && localStorage && localStorage.setItem("user-token", token);
    !token && localStorage && localStorage.removeItem("user-token");
    commit("setToken", token);
    setDefaultAuthHeaders(token);
  },

  async loginRB() {
    await accountRedirectSDK.loginRedirect();
  },

  async login({ commit, dispatch }, rbJWT) {
    try {
      commit("authRequest");
      const { success, message, data } = await authSerivce.loginWithRB(rbJWT);

      if (!success) {
        commit("authError");
        return { success, message };
      }

      const token = data.token;
      await dispatch("setToken", token);
      dispatch("getProfile");
      return { success, message };
    } catch {
      showAlert("Ошибка авторизации");
    }
  },

  async logout({ commit }) {
    commit("authLogout");
    localStorage.removeItem("user-token");
    setDefaultAuthHeaders("");

    const rbUser = accountRedirectSDK.getUser();
    if (rbUser) {
      try {
        await accountRedirectSDK.logout();
      } catch (e) {
        console.log(e);
      }
    }
  },

  async getProfile({ commit, dispatch }) {
    let result = false;
    commit("authRequest");
    try {
      const { data, success } = await userService.getProfile();
      if (success) {
        commit("authSuccess", data);
        result = data;
        dispatch("checkProfileStatus");
      }
    } finally {
      if (!result) {
        commit("authError");
        dispatch("logout");
      }
    }
    return result;
  },

  async checkProfileStatus({ state }) {
    if (state.currentUser.status === UserSatus.InactiveVk) {
      openSignupModal(state.currentUser);
    }
  },

  async refreshProfile({ commit, dispatch }) {
    try {
      const { success, data } = await userService.getProfile();
      if (success) commit("setUser", data);
      else dispatch("logout");
    } catch {
      dispatch("logout");
    }
  },

  async updateProfile({ dispatch }, data) {
    const result = await authSerivce.signup(data);
    if (result.success) {
      dispatch("refreshProfile");
    }
    return result;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

function setDefaultAuthHeaders(token) {
  if (token) {
    appApi.defaults.headers.common.Authorization = "Bearer " + token;
  } else {
    delete appApi.defaults.headers.common.Authorization;
  }
}
